import { useRef } from "react";
import { FileText, ImageIcon, X, UploadCloud } from "lucide-react";

const MAX = 10 * 1024 * 1024;
const ACCEPT = "image/jpeg,image/png,image/webp,application/pdf";
const TYPES = ACCEPT.split(",");

export const validateFile = (f) =>
  !f ? null : !TYPES.includes(f.type) ? "Formato non supportato: usa una foto (JPG, PNG, WEBP) o un PDF." : f.size > MAX ? "Il file supera i 10 MB." : null;

export const FileDrop = ({ id, label, hint, file, onChange, onError, required = false }) => {
  const ref = useRef(null);
  const pick = (f) => {
    const err = validateFile(f);
    if (err) return onError(err);
    onChange(f || null);
  };
  const Icon = file?.type === "application/pdf" ? FileText : ImageIcon;
  return (
    <div data-testid={`quote-drop-${id}`}>
      <span className="eyebrow text-[#526356]">{label}{required ? "" : " (facoltativa)"}</span>
      {file ? (
        <div className="mt-3 flex items-center gap-3 rounded-2xl border border-[#3E6B48]/30 bg-[#E6ECE4] px-4 py-3">
          <span className="grid place-items-center w-10 h-10 rounded-full bg-[#FCFBF7] text-[#1B3B28] shrink-0"><Icon size={17} /></span>
          <div className="min-w-0 flex-1">
            <p className="text-sm text-[#1B3B28] truncate" data-testid={`quote-file-name-${id}`}>{file.name}</p>
            <p className="text-xs text-[#526356]">{(file.size / 1024 / 1024).toFixed(1)} MB</p>
          </div>
          <button type="button" onClick={() => { onChange(null); if (ref.current) ref.current.value = ""; }} aria-label="Rimuovi file"
            className="grid place-items-center w-9 h-9 rounded-full hover:bg-[#FCFBF7] text-[#1B3B28] transition-colors" data-testid={`quote-file-remove-${id}`}>
            <X size={15} />
          </button>
        </div>
      ) : (
        <label htmlFor={`file-${id}`} onDragOver={(e) => e.preventDefault()} onDrop={(e) => { e.preventDefault(); pick(e.dataTransfer.files[0]); }}
          className="mt-3 flex flex-col items-center justify-center text-center gap-2 rounded-2xl border border-dashed border-[#1B3B28]/25 px-4 py-8 cursor-pointer hover:border-[#3E6B48] hover:bg-[#E6ECE4]/50 transition-colors">
          <UploadCloud size={22} className="text-[#3E6B48]" />
          <span className="text-sm text-[#1B3B28]">Tocca per scegliere o trascina qui</span>
          <span className="text-xs text-[#526356]">{hint}</span>
        </label>
      )}
      <input ref={ref} id={`file-${id}`} type="file" accept={ACCEPT} className="sr-only" onChange={(e) => pick(e.target.files[0])} data-testid={`quote-file-input-${id}`} />
    </div>
  );
};
